<template>
    <div>
        <headers :title='titles'></headers>
        <loadingS v-if='loading'></loadingS>
        <div class="content"
             v-else>
            <noResouse v-if='no_Resouse'></noResouse>
            <div v-else
                 class="list_item"
                 v-for='lis,index in list'>
                <h3 class="div_cp"
                    v-if="lis.list.length != 0">{{lis.name}}</h3>
                <ul>
                    <li v-for='li,index in lis.list'>
                        <span class="div_sp">{{li.subject}}({{li.answer}})</span>
                        <div class="div_t1">
                            <em class="icon-shanchu"></em>
                            <span @click="deletes(list,index,li.id,li)">删除</span>
                        </div>
                        <div class="div_t2">
                            <i class="icon-shuaxin"></i>
                            <span @click="title(li,index,$event,lis.list,li.type,lis.name)">换题</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="change">
            <transition name="my-fade"
                        tag="div">
                <div v-show='change'
                     class="div_ss"></div>
            </transition>
            <transition name="my-slide"
                        tag="div">
                <div v-show='change'
                     class="div_bb">
                    <div class="sentence">
                        <span class="div_an">{{name}}（共<span class="s">{{(this.chalist.length)}}</span>道）</span>
                        <span class="div_d"
                              @click='cancel'>取消</span>
                        <span class="div_d"
                              @click='changes'>换一批</span>
                    </div>
                    <div v-for=" cha,index in chalist">
                        <h3 class="chap"
                            @click="chap(chalist,index,cha)">{{cha.subject}}({{cha.answer}})</h3>
                    </div>
                    <div class="nomore"
                         v-if='nomore'>当前知识点已无更多试题，点击“换一批”按钮将从新选择试题。</div>
                </div>
            </transition>
        </div>
        <div :class="num == 0 ? 'bott' : 'bottom'"
             @click='release'>
            去发布（{{num}}）
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue'
import noResouse from 'COMPONENTS/noResouse.vue'
import loadingS from 'COMPONENTS/base/tealoading.vue';

export default {
    data () {
        return {
            titles: '作业预览',
            shu: JSON.parse(localStorage.getItem('shua')),
            list: [],
            chalist: [],
            change: false,
            grade_id: this.$route.params.gradeid,
            qids: [],
            index: null,
            num: null,
            nomore: false,
            loading: true,
            huanid: null,
            types: null,
            name: null,
            no_Resouse: false
        }
    },
    async created () {
        let math_send_ok = localStorage.getItem('math_send_ok');
        if (math_send_ok == 1) {
            this.$router.go(-1);
            return false;
        }
        await this.setList()
    },
    components: {
        headers,
        noResouse,
        loadingS
    },
    computed: {},
    methods: {
        goBack () {
            this.$router.go(-1)
        },
        cancel () {
            this.change = false
        },
        deletes (list, index, id, li) {
            let that = this
            this.list.forEach(function (v, i) {
                v.list.forEach(function (c, j) {
                    if (c.id == id) {
                        if (that.num == 1) {
                            layer.open({
                                diff: 'tea',
                                title: '注意',
                                content: `已经是最后一道题了，删除即将回到选择试题页面，确定要返回吗？`,
                                btn: ['确定', '取消'],
                                yes: function () {
                                    layer.closeAll()
                                    that.$router.go(-1)
                                }
                            })
                        } else {
                            v.list.splice(index, 1)
                            that.num--
                        }
                    }
                })
            })
        },
        title (li, index, e, lis, type, name) {
            this.types = type
            this.name = name
            let that = this
            that.qids = []
            lis.forEach(function (m, n) {
                that.qids.push(m.id)
            })
            this.types = type
            this.index = index
            this.huanid = li.id
            this.$http.post(API_URL_TASK_API + "/maths/send/quick/change", {
                "grade_id": that.grade_id,
                "type": type,
                "qids": that.qids
            }).then(res => {
                if (res.data.response == 'ok') {
                    if (res.data.data.length) {
                        this.change = true
                        this.nomore = false
                        this.chalist = res.data.data
                    } else {
                        this.change = false
                        layer.tips('当前知识点没有试题可供替换')
                    }
                }
            })
        },
        chap (cha, index, chas) {
            let that = this
            this.list.forEach(function (v, i) {
                v.list.forEach(function (m, n) {
                    if (that.huanid == m.id) {
                        v.list[n].id = cha[index].id
                        v.list[n] = chas
                    }
                })
            })
            this.change = false
        },
        setList () {
            let that = this
            this.$http.post(API_URL_TASK_API + "/maths/send/quick/create", {
                "grade_id": that.grade_id,
                "list": this.shu
            }).then(res => {
                if (res.data.response == 'ok') {
                    that.loading = false
                    if (res.data.data) {
                        this.list = res.data.data
                        let num_a = null
                        this.list.forEach(function (v, i) {
                            v.list.forEach(function (m, n) {
                                num_a++
                            })
                        })
                        that.num = num_a
                    }
                }
            })
        },
        changes () {
            let that = this
            this.$http.post(API_URL_TASK_API + "/maths/send/quick/change", {
                "grade_id": this.grade_id,
                "type": that.types,
                "qids": this.qids
            }).then(res => {
                if (res.data.response == 'ok') {
                    if (res.data.data.length) {
                        this.chalist = res.data.data
                        that.nomore = false
                    } else {
                        this.chalist = []
                        that.nomore = true
                    }
                }
            })
        },
        release () {
            let datas = []
            let that = this
            let list = this.list
            this.list.forEach(function (c, i) {
                if (c.list.length) {
                    c.list.forEach(function (c, l) {
                        let obj = {};
                        obj.type = c.type;
                        obj.qid = c.id;
                        datas.push(obj);
                    })
                }
            })
            if (datas.length) {
                this.$store.commit('setData', datas);
                this.$router.push('/sx/release/21/5')  //发送
            }
        }
    },
    destroyed () {

    }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

.bottom {
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 96px / $ppr;
    font-size: $lg;
    line-height: 96px / $ppr;
    text-align: center;
    color: white;
    background: #5e89ef;
}

.bott {
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 96px / $ppr;
    font-size: $lg;
    line-height: 96px / $ppr;
    text-align: center;
    color: white;
    background: gray;
}

.list_item {
    p {
        border: 1px / $ppr solid red;
    }
}

.list_item:last-of-type {
    margin-bottom: 80px / $ppr;
}

.content {
    height: 100%;
    margin-bottom: 60px / $ppr;
    h3 {
        padding: 26px / $ppr 24px / $ppr 0px / $ppr;
        margin-bottom: 24px / $ppr;
        color: #999;
    }
    li {
        border-bottom: 1px / $ppr solid #e8e8e8;
        padding: 30px / $ppr 24px / $ppr;
        position: relative;
        background: #fff;
        &:last-child {
            border: 0;
        }
    }
    .div_sp {
        width: 50%;
        font-size: 30px / $ppr;
        color: #333;
        word-wrap: break-word;
        display: inline-block;
        line-height: 50px / $ppr;
    }
}

.div_t1 {
    display: inline-block;
    width: 132px / $ppr;
    padding: 10px / $ppr 10px / $ppr;
    border-radius: 6px;
    position: absolute;
    top: 0;
    right: 10px / $ppr;
    margin: 23px / $ppr 15px / $ppr;
    box-sizing: border-box;
    .icon-shanchu {
        width: 30px / $ppr;
        height: 30px / $ppr;
        display: inline-block;
        position: relative;
        top: 5px / $ppr;
        margin-right: 6px / $ppr;
        background-image: url(./img/delete.png);
        background-size: 100% 100%;
    }
}

.div_t2 {
    display: inline-block;
    padding: 10px / $ppr 10px / $ppr;
    border-radius: 6px;
    position: absolute;
    top: 0;
    width: 132px / $ppr;
    right: 182px / $ppr;
    margin-top: 23px / $ppr;
    box-sizing: border-box;
    .icon-shuaxin {
        width: 30px / $ppr;
        height: 30px / $ppr;
        display: inline-block;
        position: relative;
        top: 5px / $ppr;
        margin-right: 6px / $ppr;
        background-image: url(./img/change.png);
        background-size: 100% 100%;
    }
}

.div_t1 {
    color: #ff6600;
    border: #ff6600 solid 1px;
}

.div_t2 {
    color: #5e89ef;
    border: #5e89ef solid 1px;
}

.change {
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 20;
    .div_ss {
        height: 100vh;
        background: black;
        opacity: 0.4;
        transition: opacity 0.3s linear;
    }
    .div_bb {
        position: absolute;
        z-index: 10;
        bottom: 0px;
        width: 100%;
        min-height: 450px / $ppr;
        background: white;
        transition: bottom 0.3s linear;
        .s {
            color: #ff6600;
        }
        .sentence {
            height: 30px;
            margin: 20px / $ppr;
            .div_d {
                padding: 5px 5px;
                float: right;
                width: 60px;
                text-align: center;
                margin: 0 10px / $ppr;
                border-radius: 10px / $ppr;
            }
            .div_d:nth-of-type(3) {
                color: white;
                background: #5e89ef;
            }
            .div_d:nth-of-type(2) {
                background: #ff6600;
                color: white;
            }
            .div_an {
                display: inline-block;
                width: 280px / $ppr;
                line-height: 30px;
                font-weight: bold;
                @include ellipsis;
            }
        }
    }
}

.nomore {
    padding: 30px / $ppr;
}

.chap {
    padding: 30px / $ppr 20px / $ppr;
    width: 94%;
    word-wrap: break-word;
    border-top: 1px / $ppr solid #e8e8e8;
}
.my-fade-enter,
.my-fade-leave-to {
    opacity: 0 !important;
}
.my-slide-enter,
.my-slide-leave-to {
    bottom: -450px / $ppr !important;
}
</style>
